export const Reasons = [
    'Change request from customer',
    'Item is completely out of stock',
    'Required quantity is not available',
    'Item added due to mistake',
    'Customer does not want to pay for this item',
    'Other',
];